import SkeletonCard from '@ab-core/skeletonloader';
import type { WithTestId } from '@ab-core/testing';
import { getTestIdProp } from '@ab-core/testing';
import type { FC } from 'react';
import React from 'react';

type LoaderType = { counter?: number } & WithTestId;

export const Loader: FC<LoaderType> = ({ counter = 4, testId }) => {
    return (
        <>
            {[...Array(counter)].map((_i, index) => (
                <div
                    className="flex-justify-content-space-between"
                    key={index}
                    {...getTestIdProp(testId ? `${testId}-${index}` : undefined)}
                >
                    <SkeletonCard width={96} height={16} />
                    <SkeletonCard width={96} height={16} />
                </div>
            ))}
        </>
    );
};
